// extracted by mini-css-extract-plugin
export var icon = "_9k-3";
export var subtitle = "_9k-2";
export var title = "_9k-1";
export var value = "_9k-0";